import Plan from './Plan/Plan';
import usePlanStore from '../../../store/planStore';
import MediaPlansTable from './MediaPlansTable/MediaPlansTable';

function MediaPlanning() {
  const { isPlanCreating } = usePlanStore();

  return !isPlanCreating ? <MediaPlansTable /> : <Plan />;
}

export default MediaPlanning;
